

<template>
<div class="row">
  <div class="col-md-3"></div>
  <div class="col-md-6 pt-20">
    <h5 class="text-center fw-600">Create Zabbix Monitors (NON-WPO)</h5>
    <div class="form-group">
      <label for="queueName">Domain Name*</label>
      <input v-model="monitorObj.domain" type="text" class="form-control">
    </div>
    <div class="form-group">
      <label for="queueName">IP</label>
      <input v-model="monitorObj.ip" type="text" class="form-control" >
    </div>
    <div class="form-group">
      <label for="queueName">Client Id*</label>
      <input v-model="monitorObj.clientId" type="text" class="form-control" >
    </div>
    <div class="form-group">
      <label for="queueName">Hostbill Service Id*</label>
      <input v-model="monitorObj.hbServiceId" type="text" class="form-control" >
    </div>
    <div class="form-group">
      <label for="queueName">Hostname*</label>
      <input v-model="monitorObj.hbHostname" type="text" class="form-control">
    </div>
    <button @click="saveMonitor" :disabled="!monitorObj.domain || !monitorObj.hbServiceId || !monitorObj.hbHostname || loading" class="btn btn-primary pull-right">
      Save <i v-if="loading" class="fa fa-spin fa-spinner"></i>
    </button>
  </div>
</div>
</template>
<script>
export default {
  data() {
    return {
      monitorObj: {
      },
      loading: false,
    }
  },
  methods: {
    async saveMonitor() {
      try {
        this.loading = true;
        const response = await this.$http.post('/monitor/create-non-wpo-monitors', {
          grant_type: 'token',
          domain: this.monitorObj.domain,
          hbServiceId: this.monitorObj.hbServiceId,
          hbHostname: this.monitorObj.hbHostname,
          ip: this.monitorObj.ip,
          clientId: this.monitorObj.clientId,
        })
        console.log('response', response.data)
        this.showToast({message: `You have successfully created monitor with monitor id #${response.data.monitorId}.` , duration: 4000}, true, 'success')
        this.monitorObj = {}
      }
      catch (e) {
        console.log('error', e.toString())
        this.showToast({message: `Something went wrong while creating monitor. ${e.toString()}` , duration: 2000}, true, 'danger')

      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>

</style>